<template>
  <div class="in-overlay">
    <div>
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {};
</script>

<style lang="scss" scoped>
.in-overlay {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  opacity: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%;

    .loader {
      height: 32px;
      width: 32px;
      background: url("/images/loader.gif") no-repeat;
    }
  }
}
</style>
